<div class="mes-terminal-wrap mes-terminal-dialog">
	@if (task.alias != 'Off') {
	<h1>
		<span class="lightyellow">{{ employee.firstName }} {{ employee.lastName }}</span>
		<br />
		Du er nu tjekket ind på opgaven
		<br />
		<span>{{ task.name }}</span>
	</h1>
	} @else {
	<h1>
		<span class="lightyellow">{{ employee.firstName }} {{ employee.lastName }}</span>
		<br />
		Du er nu tjekket ud
		<br />
	</h1>
	}

	<div style="display: flex; flex-direction: row; justify-content: center; margin-top: 64px">
		<button class="mes-terminal-button" id="task-change" (click)="changeTask()">
			<div class="icon">
				<img src="./assets/mes/terminal/arrow--left.svg" />
			</div>
			<div>Skift til en anden opgave</div>
		</button>

		<button class="mes-terminal-button icon-right" id="task-ok" (click)="confirmSelection()">
			<div class="icon">
				<img src="./assets/mes/terminal/arrow--right.svg" />
			</div>
			<div>
				Ok (lukker om
				<span id="countdown" class="lightyellow">{{ timer }}</span>
				sekunder)
			</div>
		</button>
	</div>
</div>
